var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line0, _path, _path2, _circle0, _circle1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrongTies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c6cf0",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#7c6cf0",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c6cf0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5a5a66"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ab",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5082ef"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 230.8,
    y1: 111.7,
    x2: 182.6,
    y2: 173.4,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182.6,
    y1: 173.4,
    x2: 127.6,
    y2: 163.7,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 127.6,
    y1: 163.7,
    x2: 81,
    y2: 128.2,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 128.2,
    x2: 134.2,
    y2: 70.8,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 134.2,
    y1: 70.8,
    x2: 199.6,
    y2: 68,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 199.6,
    y1: 68,
    x2: 171.7,
    y2: 111.8,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 171.7,
    y1: 111.8,
    x2: 230.8,
    y2: 111.7,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 230.8,
    y1: 111.7,
    x2: 81,
    y2: 128.2,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 182.6,
    y1: 173.4,
    x2: 171.7,
    y2: 111.8,
    stroke: "#3a3a44",
    strokeWidth: 1.1,
    strokeOpacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230.8,
    cy: 111.7,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.6,
    cy: 173.4,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 163.7,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 128.2,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.2,
    cy: 70.8,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.6,
    cy: 68,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.7,
    cy: 111.8,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.6,
    cy: 173.4,
    r: 30,
    fill: "url(#glow)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.2,
    cy: 70.8,
    r: 30,
    fill: "url(#glow)"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 173,
    y1: 153.1,
    x2: 143.8,
    y2: 91.1,
    stroke: "#7c6cf0",
    strokeWidth: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 82.1 L148.3 89.0 L139.3 93.3 Z",
    fill: "#7c6cf0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3 162.1 L177.5 150.9 L168.5 155.2 Z",
    fill: "#7c6cf0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.6,
    cy: 173.4,
    r: 9,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.2,
    cy: 70.8,
    r: 9,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongTies);
export default __webpack_public_path__ + "static/media/strong-ties.3bce53803077d6aefd1e254f2d8fb572.svg";
export { ForwardRef as ReactComponent };